export class RenderBudgetManager {
  constructor() {
    this.dirty = true;
    this.motionUntil = 0;
  }

  request(framesMs = 0) {
    this.dirty = true;
    if (framesMs) this.motionUntil = Math.max(this.motionUntil, performance.now() + framesMs);
  }

  shouldRender(continuous = false) {
    return this.dirty || continuous || performance.now() < this.motionUntil;
  }

  consumed() {
    this.dirty = false;
  }
}
